import { useEffect, useState, type ReactElement } from 'react';
import { Link, useOutletContext, useParams } from 'react-router';
import { listerEnvironnements, type EnvironnementConnu } from '../environnements.js';
import { EchecApi } from '../api.js';
import { CHEMINS } from '../routes.js';

interface Espace { readonly code: string; readonly nom: string; readonly role: string }

const LIBELLE: Record<EnvironnementConnu['nature'], { titre: string; detail: string }> = {
  test: { titre: 'TEST', detail: 'Environnement de test' },
  production: { titre: 'PRODUCTION', detail: 'Environnement de production' },
};

/**
 * LES ENVIRONNEMENTS D UN PROJET [contrat 28-CH].
 *
 * RUBRIQUE PROPRE, et non un bandeau au-dessus de l Outlet : deux cartes
 * TEST/PROD affichees au-dessus de l editeur, des executions et des
 * parametres seraient du bruit permanent. Un contexte permanent, plus tard,
 * sera un SELECTEUR ou un badge -- pas cet ecran.
 *
 * LECTURE SEULE, DELIBEREMENT. Aucun geste n existe : les deux environnements
 * naissent avec le projet [28-CB]. 29-G enrichira CES lignes -- version
 * deployee, dernier deploiement -- sans changer leur concept.
 *
 * LE LIBELLE EST DERIVE DE LA NATURE, jamais stocke : `nature` est une valeur
 * fermee, l affichage est une affaire d interface [28-CC]. `Record` sur le
 * type ferme : ajouter une nature un jour ferait rougir `tsc` ici.
 */
export function Environnements(): ReactElement {
  const espace = useOutletContext<Espace>();
  const { projet } = useParams<{ projet: string }>();
  const code = projet ?? '';
  const [liste, poserListe] = useState<readonly EnvironnementConnu[] | undefined>(undefined);
  const [echec, poserEchec] = useState<string | undefined>(undefined);

  useEffect(() => {
    let vivant = true;
    void (async () => {
      try {
        const r = await listerEnvironnements(espace.code, code);
        if (vivant) poserListe(r.environnements);
      } catch (e) {
        // Le code metier se lit dans `detail`, jamais deduit du statut.
        if (vivant) poserEchec(e instanceof EchecApi
          ? e.detail.code : 'Chargement impossible.');
      }
    })();
    return () => { vivant = false; };
  }, [espace.code, code]);

  if (echec !== undefined) {
    return <p className="message message--refus">{echec}</p>;
  }
  if (liste === undefined) {
    return <p className="discret">Chargement...</p>;
  }
  return (
    <div className="grille">
      {liste.map((e) => (
        <Link className="carte" key={e.nature}
              to={CHEMINS.configurationEnvironnement(espace.code, code, e.nature)}>
          <h2 className="carte__titre">{LIBELLE[e.nature].titre}</h2>
          <p className="carte__detail">{LIBELLE[e.nature].detail}</p>
          <p className="discret">Configuration →</p>
        </Link>
      ))}
    </div>
  );
}
